var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dash-library__list-item" }, [
    _c(
      "a",
      { staticClass: "dash-library__link", on: { click: _vm.downloadPricing } },
      [
        _c("div", { staticClass: "dash-library__name" }, [
          _c("i", { staticClass: "fa fa-file documents__link-icon" }),
          _vm._v(" " + _vm._s(_vm.document.name))
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }